<!-- Modal -->
<div
  class="modal fade"
  id="nuevoPersonaModal"
  tabindex="-1"
  aria-labelledby="nuevoPersonaModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="nuevoPersonaModalLabel">
          {{ tipoModal === "venta" ? "Nueva Venta" : "Nueva Persona" }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <!-- Formulario para agregar persona -->
        <form (ngSubmit)="agregarPersona()">
          <div *ngIf="seccionActual === 'datosPersonales'">
            <h6>Datos Personales</h6>

            <div class="row">
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="nombre" class="form-label">Nombre</label>
                <input
                  type="text"
                  class="form-control"
                  id="nombre"
                  [(ngModel)]="nuevaPersona.nombre"
                  name="nombre"
                  placeholder="Escriba el nombre"
                  required
                />
                <div *ngIf="errores['nombre']" class="text-danger">
                  {{ errores["nombre"] }}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="apellido" class="form-label">Apellido</label>
                <input
                  type="text"
                  class="form-control"
                  id="apellido"
                  [(ngModel)]="nuevaPersona.apellido"
                  name="apellido"
                  placeholder="Escriba el apellido"
                  required
                />
                <div *ngIf="errores['apellido']" class="text-danger">
                  {{ errores["apellido"] }}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="telefono" class="form-label">Teléfono</label>
                <input
                  type="text"
                  class="form-control"
                  id="telefono"
                  [(ngModel)]="nuevaPersona.telefono"
                  name="telefono"
                  placeholder="Escriba el teléfono"
                  required
                />
                <div *ngIf="errores['telefono']" class="text-danger">
                  {{ errores["telefono"] }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="fechaNacimiento" class="form-label"
                  >Fecha Nacimiento</label
                >
                <div class="input-group">
                  <input
                    class="form-control"
                    id="fechaNacimiento"
                    [(ngModel)]="nuevaPersona.fechaNacimiento"
                    name="fechaNacimiento"
                    ngbDatepicker
                    #d="ngbDatepicker"

                    (input)="onFechaInput($event, d)"
                    [maxDate]="maxDate"
                    [minDate]="minDate"
                    placeholder="DD/MM/YYYY"
                    maxlength="10"
                    required
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3"
                    (click)="d.toggle()"
                    type="button"
                  ></button>
                  <div *ngIf="errores['fechaNacimiento']" class="text-danger">
                    {{ errores["fechaNacimiento"] }}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="documento" class="form-label">Documento</label>
                <input
                  type="text"
                  class="form-control"
                  id="documento"
                  [(ngModel)]="nuevaPersona.documento"
                  name="documento"
                  placeholder="Escriba el documento"
                  required
                />
                <div *ngIf="errores['documento']" class="text-danger">
                  {{ errores["documento"] }}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="cuil" class="form-label">CUIL</label>
                <input
                  type="text"
                  class="form-control"
                  id="cuil"
                  [(ngModel)]="nuevaPersona.cuil"
                  name="cuil"
                  placeholder="Escriba el CUIL"
                  required
                />
                <div *ngIf="errores['cuil']" class="text-danger">
                  {{ errores["cuil"] }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="cuilTitular" class="form-label">CUIL Titular</label>
                <input
                  type="text"
                  class="form-control"
                  id="cuilTitular"
                  [(ngModel)]="nuevaPersona.cuilTitular"
                  name="cuilTitular"
                  placeholder="Escriba el CUIL del titular"
                  required
                  (change)="onCuilTitularChange()"
                />
                <div *ngIf="errores['cuilTitular']" class="text-danger">
                  {{ errores["cuilTitular"] }}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="idSexo" class="form-label">Sexo</label>
                <select
                  class="form-control"
                  id="idSexo"
                  [(ngModel)]="nuevaPersona.idSexo"
                  name="idSexo"
                  required
                >
                  <option value="" disabled selected>Seleccione sexo</option>
                  <option *ngFor="let sexo of sexos" [value]="sexo.id">
                    {{ sexo.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idSexo']" class="text-danger">
                  {{ errores["idSexo"] }}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="idParentesco" class="form-label">Parentesco</label>
                <select
                  class="form-control"
                  id="idParentesco"
                  [(ngModel)]="nuevaPersona.idParentesco"
                  name="idParentesco"
                  required
                >
                  <option value="" disabled selected>
                    Seleccione el parentesco
                  </option>
                  <option
                    *ngFor="let parentesco of parentescos"
                    [value]="parentesco.id"
                  >
                    {{ parentesco.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idParentesco']" class="text-danger">
                  {{ errores["idParentesco"] }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="idEstadoCivil" class="form-label"
                  >Estado Civil</label
                >
                <select
                  class="form-control"
                  id="idEstadoCivil"
                  [(ngModel)]="nuevaPersona.idEstadoCivil"
                  name="idEstadoCivil"
                  required
                >
                  <option value="" disabled selected>
                    Seleccione estado civil
                  </option>
                  <option
                    *ngFor="let estadoCivil of estadosCiviles"
                    [value]="estadoCivil.id"
                  >
                    {{ estadoCivil.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idEstadoCivil']" class="text-danger">
                  {{ errores["idEstadoCivil"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="idNacionalidad" class="form-label"
                  >Nacionalidad</label
                >
                <select
                  class="form-control"
                  id="idNacionalidad"
                  [(ngModel)]="nuevaPersona.idNacionalidad"
                  name="idNacionalidad"
                  required
                >
                  <option value="" disabled selected>
                    Seleccione nacionalidad
                  </option>
                  <option
                    *ngFor="let nacionalidad of nacionalidades"
                    [value]="nacionalidad.id"
                  >
                    {{ nacionalidad.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idNacionalidad']" class="text-danger">
                  {{ errores["idNacionalidad"] }}
                </div>
              </div>

              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="provincia" class="form-label">Provincia</label>
                <select
                  class="form-control"
                  id="provincia"
                  [(ngModel)]="nuevaPersona.provincia"
                  name="provincia"
                  (change)="onProvinciaChange($event)"
                  required
                >
                  <option value="" disabled selected>
                    Seleccione provincia
                  </option>
                  <option
                    *ngFor="let provincia of provincias"
                    [value]="provincia.id"
                  >
                    {{ provincia.descripcion }}
                  </option>
                </select>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="localidad" class="form-label">Localidad</label>
                <select
                  class="form-control"
                  id="localidad"
                  [(ngModel)]="nuevaPersona.idLocalidad"
                  name="idLocalidad"
                  [disabled]="!localidades.length"
                  required
                >
                  <option value="" disabled selected>
                    Seleccione localidad
                  </option>
                  <option
                    *ngFor="let localidad of localidades"
                    [value]="localidad.id"
                  >
                    {{ localidad.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idLocalidad']" class="text-danger">
                  {{ errores["idLocalidad"] }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="domicilio" class="form-label">Domicilio</label>
                <input
                  type="text"
                  class="form-control"
                  id="domicilio"
                  [(ngModel)]="nuevaPersona.domicilio"
                  name="domicilio"
                  placeholder="Escriba el domicilio"
                  required
                />
                <div *ngIf="errores['domicilio']" class="text-danger">
                  {{ errores["domicilio"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="numeroDomicilio" class="form-label"
                  >N° Domicilio</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="numeroDomicilio"
                  [(ngModel)]="nuevaPersona.numeroDomicilio"
                  name="numeroDomicilio"
                  placeholder="Escriba el número de domicilio"
                  required
                />
                <div *ngIf="errores['numeroDomicilio']" class="text-danger">
                  {{ errores["numeroDomicilio"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="piso" class="form-label">Piso (opcional)</label>
                <input
                  type="text"
                  class="form-control"
                  id="piso"
                  [(ngModel)]="nuevaPersona.piso"
                  name="piso"
                  placeholder="Escriba el piso"
                  required
                />
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="departamento" class="form-label"
                  >Departamento (opcional)</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="departamento"
                  [(ngModel)]="nuevaPersona.departamento"
                  name="departamento"
                  placeholder="Escriba el departamento"
                  required
                />
              </div>
            </div>

            <button
              type="button"
              class="btn btn-primary float-end"
              (click)="siguiente()"
            >
              Siguiente
            </button>
          </div>

          <div *ngIf="seccionActual === 'datosAfiliacion'">
            <h6>Datos de Afiliación</h6>

            <div class="row">
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="idTipoBeneficiario" class="form-label"
                  >Tipo Beneficiario</label
                >
                <select
                  class="form-control"
                  id="idTipoBeneficiario"
                  [(ngModel)]="nuevaPersona.idTipoBeneficiario"
                  name="idTipoBeneficiario"
                  required
                  [disabled]="tieneTitular"
                >
                  <option value="" disabled selected>
                    Seleccione el tipo de beneficiario
                  </option>
                  <option
                    *ngFor="let tipoBeneficiario of tiposBeneficiarios"
                    [value]="tipoBeneficiario.id"
                  >
                    {{ tipoBeneficiario.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idTipoBeneficiario']" class="text-danger">
                  {{ errores["idTipoBeneficiario"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="idPlan" class="form-label">Plan</label>
                <select
                  class="form-control"
                  id="idPlan"
                  [(ngModel)]="nuevaPersona.idPlan"
                  name="idPlan"
                  required
                  [disabled]="tieneTitular"
                >
                  <option value="" disabled selected>Seleccione el plan</option>
                  <option *ngFor="let plan of planes" [value]="plan.id">
                    {{ plan.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idPlan']" class="text-danger">
                  {{ errores["idPlan"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="idObraSocial" class="form-label">Obra Social</label>
                <select
                  class="form-control"
                  id="idObraSocial"
                  [(ngModel)]="nuevaPersona.idObraSocial"
                  name="idObraSocial"
                  required
                  [disabled]="tieneTitular"
                >
                  <option value="" disabled selected>
                    Seleccione la obra social
                  </option>
                  <option *ngFor="let obra of obrasSociales" [value]="obra.id">
                    {{ obra.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idObraSocial']" class="text-danger">
                  {{ errores["idObraSocial"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="idRevista" class="form-label">Revista</label>
                <select
                  class="form-control"
                  id="idRevista"
                  [(ngModel)]="nuevaPersona.idRevista"
                  name="idRevista"
                  required
                  [disabled]="tieneTitular"
                >
                  <option value="" disabled selected>
                    Seleccione la revista
                  </option>
                  <option *ngFor="let revista of revistas" [value]="revista.id">
                    {{ revista.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idRevista']" class="text-danger">
                  {{ errores["idRevista"] }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="empresa" class="form-label">Empresa</label>
                <div class="dropdown position-relative" ngbDropdown>
                  <div class="input-group">
                    <button
                      class="form-control text-start d-flex justify-content-between align-items-center dropdown-toggle text-truncate"
                      type="button"
                      ngbDropdownToggle
                      [id]="'empresaDropdownModal'"
                      [disabled]="tieneTitular"
                    >
                      <span
                        *ngIf="empresaSeleccionada"
                        class="text-truncate me-2"
                        >{{ empresaSeleccionada.razonSocial }} ({{
                          empresaSeleccionada.cuit
                        }})</span
                      >
                      <span *ngIf="!empresaSeleccionada"
                        >Seleccione una empresa</span
                      >
                    </button>
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      [disabled]="tieneTitular"
                      (click)="abrirModalEmpresa()"
                      title="Agregar nueva empresa"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                  <div
                    ngbDropdownMenu
                    [attr.aria-labelledby]="'empresaDropdownModal'"
                    class="dropdown-menu w-100 empresa-dropdown-menu"
                  >
                    <div class="px-3 py-2">
                      <input
                        type="text"
                        class="form-control mb-2"
                        placeholder="Buscar por razón social o CUIT (mínimo 3 caracteres)"
                        [(ngModel)]="empresaFiltro"
                        (input)="filtrarEmpresas()"
                        (click)="$event.stopPropagation()"
                        name="empresaFiltro"
                      />
                    </div>
                    <div class="dropdown-divider"></div>
                    <div
                      *ngIf="empresaFiltro.length < 3"
                      class="px-3 py-2 text-muted"
                    >
                      Escriba al menos 3 caracteres para buscar
                    </div>
                    <div
                      *ngIf="
                        empresaFiltro.length >= 3 &&
                        empresaFiltrada.length === 0
                      "
                      class="px-3 py-2 text-warning"
                    >
                      No se encontraron empresas con ese filtro
                    </div>
                    <div
                      class="dropdown-items-container"
                      *ngIf="empresaFiltrada.length > 0"
                    >
                      <button
                        *ngFor="let empresa of empresaFiltrada"
                        class="dropdown-item"
                        type="button"
                        (click)="onEmpresaSeleccionada(empresa.cuit)"
                      >
                        {{ empresa.razonSocial }} ({{ empresa.cuit }})
                      </button>
                    </div>
                  </div>
                </div>
                <div *ngIf="errores['cuitEmpresa']" class="text-danger">
                  {{ errores["cuitEmpresa"] }}
                </div>
              </div>

              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="numeroAfiliado" class="form-label"
                  >Numero Afiliado (opcional)</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="numeroAfiliado"
                  [(ngModel)]="nuevaPersona.numeroAfiliado"
                  name="numeroAfiliado"
                  placeholder="Escriba el número de afiliado"
                />
                <div *ngIf="errores['numeroAfiliado']" class="text-danger">
                  {{ errores["numeroAfiliado"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="fechaVenta" class="form-label"
                  >Fecha Venta
                  <span *ngIf="tipoModal === 'venta'" class="text-danger"
                    >*</span
                  ><span *ngIf="tipoModal === 'persona'"
                    >(opcional)</span
                  ></label
                >
                <div class="input-group">
                  <input
                    class="form-control"
                    id="fechaVenta"
                    [(ngModel)]="nuevaPersona.fechaVenta"
                    name="fechaVenta"
                    ngbDatepicker
                    #fv="ngbDatepicker"
                    (input)="onFechaInput($event, fv)"
                    placeholder="DD/MM/YYYY"
                    maxlength="10"
                    [required]="tipoModal === 'venta'"
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3"
                    (click)="fv.toggle()"
                    type="button"
                  ></button>
                </div>
                <div *ngIf="errores['fechaVenta']" class="text-danger">
                  {{ errores["fechaVenta"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="idVendedor" class="form-label">
                  Vendedor
                  <span *ngIf="tipoModal === 'venta'" class="text-danger"
                    >*</span
                  >
                  <span *ngIf="tipoModal === 'persona'">(opcional)</span>
                </label>
                <div class="input-group">
                  <select
                    class="form-control"
                    id="idVendedor"
                    [(ngModel)]="nuevaPersona.idVendedor"
                    name="idVendedor"
                    [required]="tipoModal === 'venta'"
                    [ngClass]="{ 'is-invalid': errores['idVendedor'] }"
                  >
                    <option value="" disabled selected>
                      Seleccione un vendedor
                    </option>
                    <option
                      *ngFor="let vendedor of vendedores"
                      [value]="vendedor.id"
                    >
                      {{ vendedor.apellido }}, {{ vendedor.nombre }} ({{
                        vendedor.canalVenta
                      }})
                    </option>
                  </select>
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    (click)="abrirModalVendedor()"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
                <div
                  *ngIf="errores['idVendedor']"
                  class="invalid-feedback d-block"
                >
                  {{ errores["idVendedor"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="aporteInicial" class="form-label">
                  Monto de Aporte
                  <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    id="aporteInicial"
                    [(ngModel)]="nuevaPersona.aporteInicial"
                    name="aporteInicial"
                    placeholder="Ingrese monto de aporte"
                    step="0.01"
                    min="0"
                    required
                    [disabled]="tieneTitular"
                    [ngClass]="{ 'is-invalid': errores['aporteInicial'] }"
                  />
                </div>
                <div *ngIf="errores['aporteInicial']" class="text-danger">
                  {{ errores["aporteInicial"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <div class="form-check mt-4">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="planFijoModal"
                    [(ngModel)]="nuevaPersona.planFijo"
                    name="planFijo"
                    [disabled]="tieneTitular"
                  />
                  <label class="form-check-label" for="planFijoModal">
                    Plan Fijo
                  </label>
                </div>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-secondary"
              (click)="anterior()"
            >
              Anterior
            </button>
            <button
              *ngIf="!tieneTitular"
              type="button"
              class="btn btn-warning mx-2"
              (click)="guardarPersonaYAgregarAdherentes()"
            >
              Guardar persona y agregar adherentes
            </button>
            <button type="submit" class="btn btn-primary float-end">
              Agregar
            </button>
          </div>

          <div *ngIf="seccionActual === 'nuevaPersonaAdherente'">
            <!-- Nueva Sección para Adherentes -->
            <h6>Agregar Adherente</h6>

            <div class="row">
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="nombre" class="form-label">Nombre</label>
                <input
                  type="text"
                  class="form-control"
                  id="nombre"
                  [(ngModel)]="nuevaPersona.nombre"
                  name="nombre"
                  placeholder="Escriba el nombre"
                  required
                />
                <div *ngIf="errores['nombre']" class="text-danger">
                  {{ errores["nombre"] }}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="apellido" class="form-label">Apellido</label>
                <input
                  type="text"
                  class="form-control"
                  id="apellido"
                  [(ngModel)]="nuevaPersona.apellido"
                  name="apellido"
                  placeholder="Escriba el apellido"
                  required
                />
                <div *ngIf="errores['apellido']" class="text-danger">
                  {{ errores["apellido"] }}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="telefono" class="form-label">Teléfono</label>
                <input
                  type="text"
                  class="form-control"
                  id="telefono"
                  [(ngModel)]="nuevaPersona.telefono"
                  name="telefono"
                  placeholder="Escriba el teléfono"
                  required
                />
                <div *ngIf="errores['telefono']" class="text-danger">
                  {{ errores["telefono"] }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="fechaNacimiento" class="form-label"
                  >Fecha Nacimiento</label
                >
                <div class="input-group">
                  <input
                    class="form-control"
                    id="fechaNacimiento"
                    [(ngModel)]="nuevaPersona.fechaNacimiento"
                    name="fechaNacimiento"
                    ngbDatepicker
                    #d="ngbDatepicker"

                    (input)="onFechaInput($event, d)"
                    [maxDate]="maxDate"
                    [minDate]="minDate"
                    placeholder="DD/MM/YYYY"
                    maxlength="10"
                    required
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3"
                    (click)="d.toggle()"
                    type="button"
                  ></button>
                  <div *ngIf="errores['fechaNacimiento']" class="text-danger">
                    {{ errores["fechaNacimiento"] }}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="documento" class="form-label">Documento</label>
                <input
                  type="text"
                  class="form-control"
                  id="documento"
                  [(ngModel)]="nuevaPersona.documento"
                  name="documento"
                  placeholder="Escriba el documento"
                  required
                />
                <div *ngIf="errores['documento']" class="text-danger">
                  {{ errores["documento"] }}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="cuil" class="form-label">CUIL</label>
                <input
                  type="text"
                  class="form-control"
                  id="cuil"
                  [(ngModel)]="nuevaPersona.cuil"
                  name="cuil"
                  placeholder="Escriba el CUIL"
                  required
                />
                <div *ngIf="errores['cuil']" class="text-danger">
                  {{ errores["cuil"] }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="cuilTitular" class="form-label">CUIL Titular</label>
                <input
                  type="text"
                  class="form-control"
                  id="cuilTitular"
                  [(ngModel)]="nuevaPersona.cuilTitular"
                  name="cuilTitular"
                  placeholder="Escriba el CUIL del titular"
                  required
                  readonly
                />
                <div *ngIf="errores['cuilTitular']" class="text-danger">
                  {{ errores["cuilTitular"] }}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="idSexo" class="form-label">Sexo</label>
                <select
                  class="form-control"
                  id="idSexo"
                  [(ngModel)]="nuevaPersona.idSexo"
                  name="idSexo"
                  required
                >
                  <option value="" disabled selected>Seleccione sexo</option>
                  <option *ngFor="let sexo of sexos" [value]="sexo.id">
                    {{ sexo.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idSexo']" class="text-danger">
                  {{ errores["idSexo"] }}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xs-12 mb-4">
                <label for="idParentesco" class="form-label">Parentesco</label>
                <select
                  class="form-control"
                  id="idParentesco"
                  [(ngModel)]="nuevaPersona.idParentesco"
                  name="idParentesco"
                  required
                >
                  <option value="" disabled selected>
                    Seleccione el parentesco
                  </option>
                  <option
                    *ngFor="let parentesco of parentescos"
                    [value]="parentesco.id"
                  >
                    {{ parentesco.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idParentesco']" class="text-danger">
                  {{ errores["idParentesco"] }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="idEstadoCivil" class="form-label"
                  >Estado Civil</label
                >
                <select
                  class="form-control"
                  id="idEstadoCivil"
                  [(ngModel)]="nuevaPersona.idEstadoCivil"
                  name="idEstadoCivil"
                  required
                >
                  <option value="" disabled selected>
                    Seleccione estado civil
                  </option>
                  <option
                    *ngFor="let estadoCivil of estadosCiviles"
                    [value]="estadoCivil.id"
                  >
                    {{ estadoCivil.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idEstadoCivil']" class="text-danger">
                  {{ errores["idEstadoCivil"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="idNacionalidad" class="form-label"
                  >Nacionalidad</label
                >
                <select
                  class="form-control"
                  id="idNacionalidad"
                  [(ngModel)]="nuevaPersona.idNacionalidad"
                  name="idNacionalidad"
                  required
                >
                  <option value="" disabled selected>
                    Seleccione nacionalidad
                  </option>
                  <option
                    *ngFor="let nacionalidad of nacionalidades"
                    [value]="nacionalidad.id"
                  >
                    {{ nacionalidad.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idNacionalidad']" class="text-danger">
                  {{ errores["idNacionalidad"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="provincia" class="form-label">Provincia</label>
                <select
                  class="form-control"
                  id="provincia"
                  [(ngModel)]="nuevaPersona.provincia"
                  name="provincia"
                  (change)="onProvinciaChange($event)"
                  required
                >
                  <option value="" disabled selected>
                    Seleccione provincia
                  </option>
                  <option
                    *ngFor="let provincia of provincias"
                    [value]="provincia.id"
                  >
                    {{ provincia.descripcion }}
                  </option>
                </select>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="localidad" class="form-label">Localidad</label>
                <select
                  class="form-control"
                  id="localidad"
                  [(ngModel)]="nuevaPersona.idLocalidad"
                  name="idLocalidad"
                  [disabled]="!localidades.length"
                  required
                >
                  <option value="" disabled selected>
                    Seleccione localidad
                  </option>
                  <option
                    *ngFor="let localidad of localidades"
                    [value]="localidad.id"
                  >
                    {{ localidad.descripcion }}
                  </option>
                </select>
                <div *ngIf="errores['idLocalidad']" class="text-danger">
                  {{ errores["idLocalidad"] }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="domicilio" class="form-label">Domicilio</label>
                <input
                  type="text"
                  class="form-control"
                  id="domicilio"
                  [(ngModel)]="nuevaPersona.domicilio"
                  name="domicilio"
                  placeholder="Escriba el domicilio"
                  required
                />
                <div *ngIf="errores['domicilio']" class="text-danger">
                  {{ errores["domicilio"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="numeroDomicilio" class="form-label"
                  >N° Domicilio</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="numeroDomicilio"
                  [(ngModel)]="nuevaPersona.numeroDomicilio"
                  name="numeroDomicilio"
                  placeholder="Escriba el número de domicilio"
                  required
                />
                <div *ngIf="errores['numeroDomicilio']" class="text-danger">
                  {{ errores["numeroDomicilio"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="piso" class="form-label">Piso (opcional)</label>
                <input
                  type="text"
                  class="form-control"
                  id="piso"
                  [(ngModel)]="nuevaPersona.piso"
                  name="piso"
                  placeholder="Escriba el piso"
                />
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="departamento" class="form-label"
                  >Departamento (opcional)</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="departamento"
                  [(ngModel)]="nuevaPersona.departamento"
                  name="departamento"
                  placeholder="Escriba el departamento"
                />
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="fechaVenta" class="form-label"
                  >Fecha Venta
                  <span *ngIf="tipoModal === 'venta'" class="text-danger"
                    >*</span
                  ><span *ngIf="tipoModal === 'persona'"
                    >(opcional)</span
                  ></label
                >
                <div class="input-group">
                  <input
                    class="form-control"
                    id="fechaVenta"
                    [(ngModel)]="nuevaPersona.fechaVenta"
                    name="fechaVenta"
                    ngbDatepicker
                    #fv="ngbDatepicker"
                    (input)="onFechaInput($event, fv)"
                    placeholder="DD/MM/YYYY"
                    maxlength="10"
                    [required]="tipoModal === 'venta'"
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3"
                    (click)="fv.toggle()"
                    type="button"
                  ></button>
                </div>
                <div *ngIf="errores['fechaVenta']" class="text-danger">
                  {{ errores["fechaVenta"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <label for="idVendedorAdherente" class="form-label">
                  Vendedor
                  <span *ngIf="tipoModal === 'venta'" class="text-danger"
                    >*</span
                  >
                  <span *ngIf="tipoModal === 'persona'">(opcional)</span>
                </label>
                <div class="input-group">
                  <select
                    class="form-control"
                    id="idVendedorAdherente"
                    [(ngModel)]="nuevaPersona.idVendedor"
                    name="idVendedor"
                    [required]="tipoModal === 'venta'"
                    [ngClass]="{ 'is-invalid': errores['idVendedor'] }"
                  >
                    <option value="" disabled selected>
                      Seleccione un vendedor
                    </option>
                    <option
                      *ngFor="let vendedor of vendedores"
                      [value]="vendedor.id"
                    >
                      {{ vendedor.apellido }}, {{ vendedor.nombre }} ({{
                        vendedor.canalVenta
                      }})
                    </option>
                  </select>
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    (click)="abrirModalVendedor()"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
                <div
                  *ngIf="errores['idVendedor']"
                  class="invalid-feedback d-block"
                >
                  {{ errores["idVendedor"] }}
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xs-12 mb-4">
                <div class="form-check mt-4">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="planFijoAdherente"
                    [(ngModel)]="nuevaPersona.planFijo"
                    name="planFijo"
                    [disabled]="true"
                  />
                  <label class="form-check-label" for="planFijoAdherente">
                    Plan Fijo
                  </label>
                </div>
              </div>
            </div>

            <button
              type="submit"
              class="btn btn-primary float-end"
              id="guardarAdherente"
            >
              Guardar Adherente
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="opcionesAdherenteModal"
  tabindex="-1"
  aria-labelledby="opcionesAdherenteModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="opcionesAdherenteModalLabel">Opciones</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p>Persona guardada correctamente. ¿Qué desea hacer a continuación?</p>
        <button
          type="button"
          class="btn btn-primary"
          id="agregarOtroAdherente"
          (click)="abrirModalNuevoAdherente()"
        >
          Agregar otro adherente
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          id="finalizar"
          data-bs-dismiss="modal"
          (click)="cerrarModal()"
        >
          Finalizar
        </button>
      </div>
    </div>
  </div>
</div>
<app-vendedor-modal #vendedorModal></app-vendedor-modal>
<app-empresa-modal #empresaModal></app-empresa-modal>





